<template>
    <div class="agreeWrap">
        <div v-if="flag == 'zh_TW'">
            <h6>更新日期：2022年04月26日</h6>
            <h6>生效日期：2022年04月26日</h6>
            <div class="bd">
                <p>
                    【重要】 在您注銷您的二周目漫畫帳號之前，請充分閱讀、理解並同意下列事項:
                </p>
                <p>
                    【特別提示】注銷二周目漫畫帳號爲不可恢複的操作，除您已授權提供至第三方的信息以外，注銷帳號後您將無法再使用本二周目漫畫帳號或找回您浏覽、收藏、參與活動的任何內容或信息(即使您使用相同的手機號碼再次注冊並使用記刻)。請確保您所申請注銷的二周目漫畫帳號應當是您本人依照《二周目用戶協議》的約定創建並由本公司提供給您本人的帳號。您應當依照本公司規定的程序或網站上的提示注銷二周目帳號。建議您在注銷前自行備份二周目帳號相關的所有信息，並請確認與本二周目帳號相關的所有服務均已進行妥善處理。注銷完成後，二周目將刪除您的個人信息或對其進行匿名化處理(法律法規另有規定的除外)。請您知悉並理解，根據相關法律法規規定相關日志記錄二周目漫畫將保留不少于6個月的時間。
                </p>
                <h6>
                    1，我們對您注銷二周目帳號的決定深表遺憾。如果您仍決定繼續進行帳號注銷，您的帳號需同時滿足以下條件:
                </h6>
                <ol class="list decimal-list textIndet10">
                    <li>
                        1.1 帳號處于安全狀態:帳號處于正常使用狀態，無被盜風險
                    </li>
                    <li>
                        1.2 帳號財産已結清，沒有未完成或存在爭議的服務:帳號中沒有資産、欠款、未結清的資金和虛擬權益;本帳號及通過本帳號接入的第三方中沒有未完成或存在爭議的服務。
                    </li>
                    <li>
                        1.3 帳號權限解除:帳號已解除與第三方産品、網站授權登錄或綁定關系。
                    </li>
                    <li>
                        1.4 帳號無任何未結爭議糾紛，包括投訴舉報或被投訴舉報。
                    </li>
                </ol>
                <h6>
                    2，二周目帳號注銷後，您將無法登錄、使用本二周目帳號，也將無法找回本記刻帳號中及與帳號相關的任何內容或信息，包括但不限于:
                </h6>
                <ol class="list decimal-list textIndet10">
                    <li>
                        2.1 個人已提交的身份信息、帳號信息等信息。
                    </li>
                    <li>
                        2.2 已查看的數據、互動、浏覽曆史等內容數據。
                    </li>
                    <li>
                        2.3 通過本二周目帳號使用、授權登錄或綁定本二周目帳號後使用的二周目或第三方服務的相關記錄將無法找回。您將無法再登錄、使用上述服務，通過上述服務曾獲得的資産或虛擬權益等財産性利益視爲您同意放棄，將無法繼續使用。您理解並同意，二周目無法協助您重新恢複上述服務。
                    </li>
                    <li>
                        2.4 帳號內錢包賬戶余額、實名認證信息、交易記錄、已綁定的銀行卡等信息將被作廢及刪除。請確認帳號內無任何資産或虛擬權益，您曾獲得的資産虛擬權益等財産性利益視爲您同意放棄，將無法繼續使用。您理解並同意，您將放棄二周目的資産或權益，二周目無法協助您恢複上述服務，也無法找回帳號相關的任何內容或信息。
                    </li>
                </ol>
                <h6>
                    3，二周目帳號注銷將導致本公司終止爲您提供服務，依《二周目用戶協議》和《隱私政策》等約定的雙方權利義務終止，依法律法規另有規定、本頁面其他條款另行約定不得終止的或依其性質不能終止的除外。
                </h6>
                <h6>
                    4，在您的二周目帳號注銷期間，如果您的帳號涉及爭議糾紛，包括但不限于:投訴、舉報、訴訟、仲裁、國家有權機關調查等，您理解並同意，二周目有權自行決定是否終止本帳號的注銷而無需另行得到您的同意。
                </h6>
                <h6>
                    5，注銷本二周目帳號並不代表本二周目帳號注銷前的賬戶行爲和相關責任得到豁免或減輕。
                </h6>
            </div>
        </div>
        <div v-if="flag == 'zh_CN'">
            <h6>更新日期：2022年04月26日
            </h6>
            <h6>生效日期：2022年04月26日</h6>
            <div class="bd">
                <p>
                    【重要】 在您注销您的二周目漫画帐号之前，请充分阅读、理解并同意下列事项:
                </p>
                <p>
                    【特别提示】注销二周目漫画帐号为不可恢复的操作，除您已授权提供至第三方的信息以外，注销帐号后您将无法再使用本二周目漫画帐号或找回您浏览、收藏、参与活动的任何内容或信息(即使您使用相同的手机号码再次注册并使用记刻)。请确保您所申请注销的二周目漫画帐号应当是您本人依照《二周目用户协议》的约定创建并由本公司提供给您本人的帐号。您应当依照本公司规定的程序或网站上的提示注销二周目帐号。建议您在注销前自行备份二周目帐号相关的所有信息，并请确认与本二周目帐号相关的所有服务均已进行妥善处理。注销完成后，二周目将删除您的个人信息或对其进行匿名化处理(法律法规另有规定的除外)。请您知悉并理解，根据相关法律法规规定相关日志记录二周目漫画将保留不少于6个月的时间。
                </p>
                <h6>
                    1，我们对您注销二周目帐号的决定深表遗憾。如果您仍决定继续进行帐号注销，您的帐号需同时满足以下条件:
                </h6>
                <ol class="list decimal-list textIndet10">
                    <li>
                        1.1 帐号处于安全状态:帐号处于正常使用状态，无被盗风险
                    </li>
                    <li>
                        1.2 帐号财产已结清，没有未完成或存在争议的服务:帐号中没有资产、欠款、未结清的资金和虚拟权益;本帐号及通过本帐号接入的第三方中没有未完成或存在争议的服务。
                    </li>
                    <li>
                        1.3 帐号权限解除:帐号已解除与第三方产品、网站授权登录或绑定关系。
                    </li>
                    <li>
                        1.4 帐号无任何未结争议纠纷，包括投诉举报或被投诉举报。
                    </li>
                </ol>
                <h6>
                    2，二周目帐号注销后，您将无法登录、使用本二周目帐号，也将无法找回本记刻帐号中及与帐号相关的任何内容或信息，包括但不限于:
                </h6>
                <ol class="list decimal-list textIndet10">
                    <li>
                        2.1 个人已提交的身份信息、帐号信息等信息。
                    </li>
                    <li>
                        2.2 已查看的数据、互动、浏览历史等内容数据。
                    </li>
                    <li>
                        2.3 通过本二周目帐号使用、授权登录或绑定本海文帐号后使用的二周目或第三方服务的相关记录将无法找回。您将无法再登录、使用上述服务，通过上述服务曾获得的资产或虚拟权益等财产性利益视为您同意放弃，将无法继续使用。您理解并同意，二周目无法协助您重新恢复上述服务。
                    </li>
                    <li>
                        2.4 帐号内钱包账户余额、实名认证信息、交易记录、已绑定的银行卡等信息将被作废及删除。请确认帐号内无任何资产或虚拟权益，您曾获得的资产虚拟权益等财产性利益视为您同意放弃，将无法继续使用。您理解并同意，您将放弃二周目的资产或权益，二周目无法协助您恢复上述服务，也无法找回帐号相关的任何内容或信息。
                    </li>
                </ol>
                <h6>
                    3，二周目帐号注销将导致本公司终止为您提供服务，依《二周目用户协议》和《隐私政策》等约定的双方权利义务终止，依法律法规另有规定、本页面其他条款另行约定不得终止的或依其性质不能终止的除外。
                </h6>
                <h6>
                    4，在您的二周目帐号注销期间，如果您的帐号涉及争议纠纷，包括但不限于:投诉、举报、诉讼、仲裁、国家有权机关调查等，您理解并同意，二周目有权自行决定是否终止本帐号的注销而无需另行得到您的同意。
                </h6>
                <h6>
                    5，注销本二周目帐号并不代表本二周目帐号注销前的账户行为和相关责任得到豁免或减轻。
                </h6>
            </div>
        </div>
        <div v-if="flag == 'en_US'">
            <h6>更新日期：2021年11月18 日</h6>
            <h6>生效日期：2021年11月18 日</h6>
            <div class="bd">
                <p>
                    【重要】 在您注銷您的二周目漫畫帳號之前，請充分閱讀、理解並同意下列事項:
                </p>
                <p>
                    【特別提示】注銷二周目漫畫帳號爲不可恢複的操作，除您已授權提供至第三方的信息以外，注銷帳號後您將無法再使用本二周目漫畫帳號或找回您浏覽、收藏、參與活動的任何內容或信息(即使您使用相同的手機號碼再次注冊並使用記刻)。請確保您所申請注銷的二周目漫畫帳號應當是您本人依照《二周目用戶協議》的約定創建並由本公司提供給您本人的帳號。您應當依照本公司規定的程序或網站上的提示注銷二周目帳號。建議您在注銷前自行備份二周目帳號相關的所有信息，並請確認與本二周目帳號相關的所有服務均已進行妥善處理。注銷完成後，二周目將刪除您的個人信息或對其進行匿名化處理(法律法規另有規定的除外)。請您知悉並理解，根據相關法律法規規定相關日志記錄二周目漫畫將保留不少于6個月的時間。
                </p>
                <h6>
                    1，我們對您注銷二周目帳號的決定深表遺憾。如果您仍決定繼續進行帳號注銷，您的帳號需同時滿足以下條件:
                </h6>
                <ol class="list decimal-list textIndet10">
                    <li>
                        1.1帳號處于安全狀態:帳號處于正常使用狀態，無被盜風險
                    </li>
                    <li>
                        1.2帳號財産已結清，沒有未完成或存在爭議的服務:帳號中沒有資産、欠款、未結清的資金和虛擬權益;本帳號及通過本帳號接入的第三方中沒有未完成或存在爭議的服務。
                    </li>
                    <li>
                        1.3帳號權限解除:帳號已解除與第三方産品、網站授權登錄或綁定關系。
                    </li>
                    <li>
                        1.4帳號無任何未結爭議糾紛，包括投訴舉報或被投訴舉報。
                    </li>
                </ol>
                <h6>
                    2，二周目帳號注銷後，您將無法登錄、使用本二周目帳號，也將無法找回本記刻帳號中及與帳號相關的任何內容或信息，包括但不限于:
                </h6>
                <ol class="list decimal-list textIndet10">
                    <li>
                        2.1 個人已提交的身份信息、帳號信息等信息。
                    </li>
                    <li>
                        2.2 已查看的數據、互動、浏覽曆史等內容數據。
                    </li>
                    <li>
                        2.3 通過本二周目帳號使用、授權登錄或綁定本二周目帳號後使用的二周目或第三方服務的相關記錄將無法找回。您將無法再登錄、使用上述服務，通過上述服務曾獲得的資産或虛擬權益等財産性利益視爲您同意放棄，將無法繼續使用。您理解並同意，二周目無法協助您重新恢複上述服務。
                    </li>
                    <li>
                        2.4 帳號內錢包賬戶余額、實名認證信息、交易記錄、已綁定的銀行卡等信息將被作廢及刪除。請確認帳號內無任何資産或虛擬權益，您曾獲得的資産虛擬權益等財産性利益視爲您同意放棄，將無法繼續使用。您理解並同意，您將放棄二周目的資産或權益，二周目無法協助您恢複上述服務，也無法找回帳號相關的任何內容或信息。
                    </li>
                </ol>
                <h6>
                    3，二周目帳號注銷將導致本公司終止爲您提供服務，依《二周目用戶協議》和《隱私政策》等約定的雙方權利義務終止，依法律法規另有規定、本頁面其他條款另行約定不得終止的或依其性質不能終止的除外。
                </h6>
                <h6>
                    4，在您的二周目帳號注銷期間，如果您的帳號涉及爭議糾紛，包括但不限于:投訴、舉報、訴訟、仲裁、國家有權機關調查等，您理解並同意，二周目有權自行決定是否終止本帳號的注銷而無需另行得到您的同意。
                </h6>
                <h6>
                    5，注銷本二周目帳號並不代表本二周目帳號注銷前的賬戶行爲和相關責任得到豁免或減輕。
                </h6>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "",
        data () {
            return {
                flag: 'zh_TW '
            }
        },
        mounted () {
            if (this.$route.query.lang) {
                this.flag = this.$route.query.lang
            } else {
                this.flag = 'zh_TW'
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .agreeWrap
        font-size 0.5rem
        padding 0.8rem
        line-height 1rem
        background #fff;
        min-height 100vh;
        height auto;
        h6
            padding 0.2rem 0
            font-size 0.7rem
        li
            margin 0.5rem 0
    .textIndet10{
        text-indent 10px;
    }
    .textIndet20{
        text-indent 20px;
    }
</style>
